import { api } from '@/lib/api/client'
import type {
  LegalDocumentAcceptancesListResponse,
} from '@/types/legal-documents'

export interface FetchLegalDocumentAcceptancesParams {
  search?: string
  date_from?: string
  date_to?: string
  document_version?: string
  page?: number
  per_page?: number
}

export async function fetchLegalDocumentAcceptances(
  params: FetchLegalDocumentAcceptancesParams
): Promise<LegalDocumentAcceptancesListResponse> {
  const query = new URLSearchParams()

  if (params.search?.trim()) {
    query.set('search', params.search.trim())
  }
  if (params.date_from) {
    query.set('date_from', params.date_from)
  }
  if (params.date_to) {
    query.set('date_to', params.date_to)
  }
  if (params.document_version?.trim()) {
    query.set('document_version', params.document_version.trim())
  }
  if (params.page) {
    query.set('page', String(params.page))
  }
  if (params.per_page) {
    query.set('per_page', String(params.per_page))
  }

  const suffix = query.toString()
  const path = suffix
    ? `/api/admin/legal-documents/acceptances?${suffix}`
    : '/api/admin/legal-documents/acceptances'

  return api.get<LegalDocumentAcceptancesListResponse>(path, { requireAuth: true })
}
